export const getYouTubeEmbeddedUrl = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    const videoId = (match && match[2].length === 11) ? match[2] : null;
    return `https://www.youtube.com/embed/${videoId}`;
};

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

export const toCamelCase = (str: string) => {
    return str
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .map((word, index) => {
            if (index === 0) return word;
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join('');
}

export const getHashFromUrl = () => {
    if (typeof window === 'undefined') return '';
    const hash = window.location.hash.replace('#', '').trim();
    return hash ? (hash.includes(' ') ? toCamelCase(hash) : hash) : '';
}

export const syncActiveCategory = (pathname: string, setActiveCategory: (category: string) => void) => {
    const checkHash = () => {
        const hash = getHashFromUrl();
        if (hash) {
            setActiveCategory(hash);
            return true;
        }
        return false;
    };

    if (checkHash()) return;

    setTimeout(() => {
        if (checkHash()) return;

        if (pathname.startsWith('/resources/blogs')) {
            setActiveCategory('blog');
            return;
        } else if (pathname.startsWith('/resources/case-study')) {
            setActiveCategory('caseStudy');
            return;
        }

        if (pathname === '/resources') {
            setActiveCategory('caseStudy');
        }
    }, 0);
};